export default (props, vars) =>
  props?.['code'] == 'national-geographic-and-the-nature-outstanding'
    ? '400px'
    : '';
